// Libraries
var React = require('react');

// Components
var Icon = require('../../common/Icon/Icon.js');

// Styles
require('./CountrySelectOverlay.scss');
require('./CountrySelectOverlayMobile.scss');

class CountrySelectOverlay extends React.Component {

	toggleMobileCountrySelector = () => {
		document.querySelector('.MainNavigationMenu__content .CountrySelectOverlay__container').classList.toggle('is-open');
		document.querySelector('.MainNavigationMenu__content .CountrySelectOverlay__toggle').classList.toggle('is-open');
	};

	handleEscKey = (event) => {
		if (event.key === 'Escape') {
			this.props.toggleCountryOverlay();
		}
	}

	render() {
		return (
			<div className={"CountrySelectOverlay" + (this.props.isCountryOverlayOpen ? " is-open" : "")} onKeyDown={this.handleEscKey}>
				<button className="CountrySelectOverlay__close js-country-start-tab" onClick={this.props.toggleCountryOverlay} ref={(button) => {this.closeButton = button}}>
					<Icon name="close" width={20} height={20} />
					<span className="u-visually-hidden">Close country overlay</span>
				</button>

				<div className="CountrySelectOverlay__toggle">
					<button className={"SearchBarDesktop__countrySelector"} onClick={this.toggleMobileCountrySelector}><Icon name="ukFlag" width={20} height={15} className={"SearchBarDesktop__countryFlag"} />English<Icon name="chevronDown" width={15} height={13} /></button>
				</div>

				<div className="CountrySelectOverlay__container">
					<div className="CountrySelectOverlay__twothird">
						<p className="CountrySelectOverlay__title">Social Channels</p>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="ukFlag" width={20} height={15} />
								English<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="http://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/SpursOfficial" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://instagram.com/spursofficial?ref=badge" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Instagram</span>
										<Icon name="instagram" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://www.youtube.com/user/spursofficial" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on YouTube</span>
										<Icon name="youtube" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://tiktok.com/spursofficial" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Tiktok</span>
										<Icon name="tiktok" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://www.threads.net/@spursofficial?hl=en-gb" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Threads</span>
										<Icon name="threads" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://www.whatsapp.com/channel/0029Va1PAqZADTOICWUvTK0D?utm_source=whatsapp&utm_medium=organic&utm_campaign=club_articlepromotion_0_2023_8" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on WhatsApp</span>
										<Icon name="whatsapp" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://www.snapchat.com/add/spursofficial" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Snapchat</span>
										<Icon name="snapchat" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem CountrySelectOverlay__socialitem--specialchar">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="koreaFlag" width={20} height={15} />
								한국어<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_KR" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://tv.naver.com/spurstv/clips" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Naver</span>
										<Icon name="naver" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem CountrySelectOverlay__socialitem--specialchar">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="chinaFlag" width={20} height={15} />
								中文<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="http://weibo.com/tottenhamhotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Weibo</span>
										<Icon name="weibo" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://v.douyin.com/iJS9sevQ/" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Tiktok</span>
										<Icon name="tiktok" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://space.bilibili.com/1286571388?spm_id_from=333.337.0.0" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Bilibili</span>
										<Icon name="bilibili" width={20} height={20} />
									</a>
								</li>
								<li>
									<span className="u-visually-hidden">Find Tottenham Hotspur on WeChat</span>
									<Icon name="wechat" width={20} height={20} />
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="indonesiaFlag" width={20} height={15} />
								Indonesian<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_ID" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="malaysiaFlag" width={20} height={15} />
								Malaysian<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_MAS" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="portugalFlag" width={20} height={15} />
								Portuguese<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="https://twitter.com/Spurs_PT" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="spanishFlag" width={20} height={15} />
								Spanish<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_ES" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="thailandFlag" width={20} height={15} />
								Thai<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_THA" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

						<div className="CountrySelectOverlay__socialitem CountrySelectOverlay__socialitem--specialchar">
							<div className="CountrySelectOverlay__socialitem__title">
								<Icon name="indiaFlag" width={20} height={15} />
								India<span className="u-visually-hidden"> social media accounts</span>
							</div>
							<ul>
								<li>
									<a href="https://www.facebook.com/TottenhamHotspur" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on Facebook</span>
										<Icon name="facebook" width={20} height={20} />
									</a>
								</li>
								<li>
									<a href="http://twitter.com/Spurs_India" target="_blank" rel="noreferrer noopener">
										<span className="u-visually-hidden">Tottenham Hotspur on X (formally Twitter)</span>
										<Icon name="x" width={20} height={20} />
									</a>
								</li>
							</ul>
						</div>

					</div>

					<div className="CountrySelectOverlay__onethird">
						<p className="CountrySelectOverlay__title">Sites & Languages</p>
						<ul className="CountrySelectOverlay__languages">
							<li>
								<a href="/">
									<Icon name="ukFlag" width={20} height={15} />English
								</a>
							</li>
							<li className="CountrySelectOverlay__languages--specialchar">
								<a href="/kr">
									<Icon name="koreaFlag" width={20} height={15} />한국어
								</a>
							</li>
						</ul>
					</div>

				</div>

			</div>
		)
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevProps.isCountryOverlayOpen === true) {
			this.closeButton.focus();
		} else {
			document.querySelector('#language').focus();
		}
	}
}

module.exports = CountrySelectOverlay;



// WEBPACK FOOTER //
// ./src/components/CountrySelect/CountrySelectOverlay.js